export const isLocalProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'local'

export const isDevProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'dev'

export const isAlphaProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'alpha'

export const isTestProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'test'

export const isBetaProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'beta'

export const isRealProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'real'

export const isStoryBookProfile = (process.env.REACT_APP_PROFILE || process.env.NEXT_PUBLIC_PROFILE) === 'storybook'
